<template>
  <div id="app">
    <gnetLogin v-if="!$store.getters.logged" v-on:login="decryptToken"/>
    <router-view v-if="$store.getters.logged"/>
  </div>
</template>

<script>
import gnetLogin from './components/login.vue'
import apiclient from '@/apiclient.js'
import numeral from 'numeral'
import metaremote from '@/metaremote.js'
//import moment from 'moment'

export default {
  name: 'app',
  components: {
    gnetLogin
  },
  mounted: function() {
    var user = JSON.parse(localStorage.getItem('user'))
    console.log(user);

    if (user != undefined) {
      console.log('User already logged in')
      this.doLogin(user)
    }

    if (numeral.locales['it'] === undefined) {
      numeral.register('locale', 'it', {
          delimiters: { thousands: '.', decimal: ',' },
          abbreviations: { thousand: 'k', million: 'm', billion: 'b', trillion: 't' },
          currency: { symbol: '€'}
      });

      numeral.locale('it');
    }
  },
  methods: {
    doLogin: function(tmp) {
      console.log(tmp);
      this.$store.commit('SET_GOOGLE_IDENTITY', tmp)

      var connection = {
        myid:       this.$store.state.user.email,
        email:      this.$store.state.user.email,
        myid_token: this.$store.state.user.id_token,
        commit:     this.$store.commit,
        userdata:   {},
        zona:       '',
        key:        ''
      }

      // eslint-disable-next-line no-undef
      OpenReplay.setUserID(this.$store.state.user.email);

      apiclient.getKey('priv.pem').then(key => {
        connection.key = key.data
        metaremote.setSecret(apiclient.secret)

        apiclient.login(connection).then(resp => {
          console.log('present myself: ' + this.$store.state.user.email) // console.log('present myid_token:'+this.$store.state.user.id_token)

          this.$store.commit('SET_CONNECTION', connection );
          this.$store.commit('SET_CONNECTION_TOKEN', resp );
          this.$store.commit('SET_LOGIN', true);
          this.$store.dispatch('initmeta');
          connection.userdata.agentcodes
          // eslint-disable-next-line no-undef
          gtag('set', {'user_id': JSON.stringify(connection.userdata.agentcodes)});
        }).catch(function(err){
          console.log(err);
        })
      }).catch(err => console.log(err))
    },
    decryptToken: function(token) {
      apiclient.validateGISToken(token).then(result => {
        this.doLogin(result)
      })
    }
  }
}
</script>

<style>
</style>
